export default {
    username: "Nombre de usuario",
    password: "Contraseña",
    button: "Entrar",
    error: "Error al iniciar sesión, verifique su información",
    page_title: "Kevi | Login",
    pattern_alt: "Vector decorativo",
    logo_alt: "Logo de Kevi",
    promo_alt: "Imagen promocional",
    username_placeholder: "Ingrese su usuario",
    password_placeholder: "**********************",
    forgot_password: "¿Olvidaste tu contraseña?",
    contact_support: "Contactar soporte",
    access_account_title: "Acceda a su cuenta",
    access_account_subtitle:
        "Gestione sus campañas, automatice sus acciones y fidelice a sus clientes.",
    auth_granted_title: "Autorización Concedida",
    auth_granted_subtitle: "Has autorizado a <strong>{0}</strong> con éxito.",
    go_to_client: "Ir a {0}",
    auth_access_title: "Autorizar Acceso",
    logged_in_as: "Has iniciado sesión como <strong>{0}</strong>.",
    authorize_access_question:
        "¿Desea autorizar el acceso a <strong>{0}</strong>?",
    yes_authorize: "Sí, Autorizar",
    switch_account: "¿No eres tú? Cambiar de cuenta",
    login_to_authorize:
        "Inicie sesión en Kevi para autorizar el acceso a <strong>{0}</strong>.",
    authorize_button: "Autorizar",
    invalid_redirect_uri: "URL de redirección inválida.",
    auth_code_generation_failed:
        "No se pudo generar el código de autorización.",
    session_expired: "Sesión expirada. Por favor, inicie sesión nuevamente.",
    server_connection_error: "Error al conectar con el servidor.",
    oauth_access_code_missing:
        "Falló la autorización. El código de acceso no fue retornado.",
    redirect_missing_info:
        "Falló la redirección. Faltan informaciones de la aplicación.",
    popup_blocked:
        "La redirección fue bloqueada. Por favor, habilite las ventanas emergentes para este sitio.",
    twofa: {
        title: "AUTENTICACIÓN DE 2 FACTORES",
        subtitle:
            "Ingrese el código de 6 dígitos generado en su aplicación de autenticación",
        verify_button: "Verificar",
        use_backup: "O use uno de sus códigos de respaldo.",
        click_here: "Haga clic aquí.",
        error_auth:
            "Fallo en la autorización. El código de acceso no fue encontrado después de la verificación.",
        error_invalid: "Código inválido o vencido. Inténtelo de nuevo.",
        error_too_many: "Demasiados intentos. Inicie sesión con su contraseña nuevamente.",
        error_expired: "Se acabó el tiempo para confirmar el código. Inicie sesión con su contraseña nuevamente.",
        error_code_used: "Este código de recuperación ya fue utilizado.",
    },
    backup: {
        title: "Ingrese su código de respaldo",
        subtitle: "Ingrese uno de sus códigos de respaldo de 8 dígitos",
        use_authenticator: "Si prefiere, use uno de sus ",
        code_link: "códigos de autenticación",
    },
    recovery: {
        link: "Recuperar contraseña",
        title: "Recuperar contraseña",
        subtitle: "Informe el usuario o el correo de su cuenta. Enviaremos un código para que cree una nueva contraseña.",
        identifier_label: "Usuario o correo",
        identifier_placeholder: "Escriba su usuario o correo",
        continue: "Continuar",
        choose_title: "Elija un canal",
        choose_subtitle: "Tiene dos formas de contacto. ¿Adónde desea recibir el código?",
        email: "Correo",
        sms: "SMS",
        code_title: "Escriba el código",
        code_subtitle: "Enviamos un código de 6 dígitos a {0}.",
        resend_prefix: "¿No recibió el código?",
        resend_action: "Haga clic aquí.",
        verify: "Verificar",
        password_title: "Cree una nueva contraseña",
        password_hint: "Use al menos 8 caracteres.",
        new_password: "Nueva contraseña",
        repeat_password: "Repita la nueva contraseña",
        save: "Guardar nueva contraseña",
        success_title: "¡Contraseña cambiada con éxito!",
        success_subtitle: "Use la nueva contraseña para entrar.",
        back_to_login: "Volver al inicio de sesión",
        blocked_title: "No es posible recuperar su contraseña",
        blocked_subtitle: "Esta cuenta no tiene correo ni teléfono verificado. Pida a un administrador de su empresa que defina una nueva contraseña.",
        blocked_back: "Volver al inicio de sesión",
        invalid_code: "Código inválido o vencido. Inténtelo de nuevo.",
        mismatch: "Las contraseñas no coinciden.",
        weak: "Use al menos 8 caracteres.",
        too_many: "Demasiados intentos. Inténtelo más tarde.",
        send_failed: "No fue posible enviar el código. Inténtelo de nuevo.",
        code_valid: "Válido por 15 minutos.",
        change_identifier: "Volver",
        resend_in: "Reenviar en {0}",
        resent: "Le enviamos un nuevo código.",
        expired: "El código venció. Solicite uno nuevo.",
        too_many_attempts: "Demasiados intentos con este código. Solicite uno nuevo.",
        network: "No fue posible conectar. Inténtelo de nuevo.",
    },
};
